import React, { useState, useRef, useEffect } from 'react';
import { Container, Box, Typography, Button, Card, CardContent, Drawer } from '@mui/material';
import PublicModeSwitch from './components/PublicModeSwitch';
import MainPage from './components/MainPage';
import dataInfo from '../data.json';
import { ReactComponent as AroundLogo } from '../AroundLogo.svg';
import Filter  from './components/Filter';
import TuneIcon from '@mui/icons-material/Tune';
import UserDetails from './components/UserDetails';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import SimpleBottomNavigation from './components/Navgitor'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { ReactComponent as CrossLogo} from '../NaVector.svg'
import { ReactComponent as FilterLogo} from '../Filter.svg'
import { ReactComponent as TabLog} from '../tabs.svg'
import Phone from '../Phone.png'

const Demo = () => {
  const [privateMode, setPrivateMode] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [userInfo, setUserInfo] = useState({})
  const [userBox, setUserBox] = useState(false)
  const [value, setValue] = React.useState(0);
  const isCardDimmed = userBox;

  const [userData, setUserData] = useState(
    dataInfo.users
  );

  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [scrollStartY, setScrollStartY] = useState(0);
  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    if (scrollContainerRef.current) {
      setIsDragging(true);
      setStartY(e.clientY);
      setScrollStartY(scrollContainerRef.current.scrollTop);
      e.preventDefault();
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && scrollContainerRef.current) {
      const deltaY = e.clientY - startY;
      scrollContainerRef.current.scrollTop = scrollStartY - deltaY;
      e.preventDefault();
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    const handleGlobalMouseMove = (e) => {
      if (isDragging && scrollContainerRef.current) {
        const deltaY = e.clientY - startY;
        scrollContainerRef.current.scrollTop = scrollStartY - deltaY;
        e.preventDefault();
      }
    };

    const handleGlobalMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleGlobalMouseMove);
      document.addEventListener('mouseup', handleGlobalMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleGlobalMouseMove);
      document.removeEventListener('mouseup', handleGlobalMouseUp);
    };
  }, [isDragging, startY, scrollStartY]);

  return (
    <Box
      sx={{ 
        overflowY: 'scroll', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
      }}
    >
      <Box sx={{ 
      overflowY: 'scroll', 
      height: '100%', 
      width: '435px',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Box 
        sx={{
          width: '330px',
          height: '624px', 
          backgroundImage: `url(${Phone})`, 
          backgroundSize: '100% 624px', 
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'center',
          overflowY: 'scroll'
        }}
      >
          <Container 
            maxWidth="sm" 
            disableGutters
            sx={{ 
              width: '94%', 
              height: '100%', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              padding: 0,
              overflow: 'hidden'
            }}
          >
            <Card
              variant="outlined"
              disableGutters
              sx={{
                mt: 8,
                width: '400px',
                position: 'relative',
                overflow: 'hidden',
                height: '97%',
                borderRadius: '50px 50px 50px 50px',
                marginTop: 0,
                marginBottom: '0%',
              }}
            >
              <Box 
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'row', 
                  alignItems: 'center',  
                  justifyContent: 'space-between', 
                  backgroundColor: '#F7F3ED', 
                  height: '88px',
                  padding: '0 16px',
                  borderBottom: '1px solid #ddd',
                  filter: isCardDimmed ? 'brightness(70%)' : 'brightness(100%)'
                }}
              >
                <AroundLogo />
                <PublicModeSwitch privateMode={privateMode} setPrivateMode={setPrivateMode} />
              </Box>
              <CardContent
                ref={scrollContainerRef}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
                sx={{
                  backgroundColor: isCardDimmed ? '#0000004f' : '#FFF',
                  overflowY: 'auto',
                  paddingBottom: '120px', 
                  height: '64%',
                  p:2,
                  marginBottom: '60px',
                  cursor: isDragging ? 'grabbing' : 'grab',
                  userSelect: 'none',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#c1c1c1',
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#a8a8a8',
                  },
                }}
              >

                {/* {privateMode && <Box
                  sx={{
                    position: 'absolute',
                    bottom: 122,
                    '@media (max-width: 380px)': {
                      bottom:110
                    },
                    left: 0,
                    right: 0,
                    padding: 2,
                    flexWrap: 'wrap',
                    display: 'flex',
                    justifyContent: 'space-around',
                    backgroundColor: 'transparent',
                    zIndex: 10,
                  }}
                >
                  <Button 
                    variant="outlined" 
                    onClick={() => setFilterOpen(true)}
                    disabled={!privateMode}
                    sx={{
                      opacity: 1,
                      backgroundColor: 'white',
                      width:'140px',
                      height: '52px',
                      color: 'black',
                      textTransform: 'none',
                      borderRadius: '65px',
                      filter: !privateMode ? 'blur(2px)' : 'none',
                      transition: 'filter 0.3s, opacity 0.3s',
                      fontSize: '20px',
                      border: '1px solid #B0B0B0',
                      borderColor: '#B0B0B0',
                      fontWeight: 400,
                      '&.Mui-disabled': {
                        pointerEvents: 'none',
                      }
                    }}
                    startIcon = {<TuneIcon />}
                  >
                    Filters
                  </Button>
                </Box>} */}
                <Box sx={{ width: "100%" }}>
                  <BottomNavigation
                    showLabels
                    value={value}
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: "94px",
                      backgroundColor: userBox ? '#0000004f' : 'white', 
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderTop: '0.5px solid #ddd',
                    }}
                  >
                    <BottomNavigationAction  icon={<LocationOnIcon sx={{ fontSize: '28px', color: '#1C38F1' }} />} 
                      sx={{        backgroundColor: "#D8EBFF", 
                        borderRadius: "50%",
                        marginLeft: "15px",
                        marginTop: "0px",
                        marginRight: "12px",
                        padding: 0,
                        height: "60px",
                        width: "60px",
                        minWidth: '60px',
                        maxWidth: '60px',
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"}}
                    />
                    <BottomNavigationAction icon={<CrossLogo sx={{width: 24, height: 24, color: '#222423'}}/>} sx={{                height: "60px",
                        width: "60px",}}/>
                    <BottomNavigationAction  icon={<FilterLogo sx={{width: 24, height: 24,}}/>} sx={{
                                      height: "60px",
                                      width: "60px",
                    }} />
                    <BottomNavigationAction  icon={<TabLog sx={{width: 24, height: 24,}}/>} sx={{                height: "60px",
                        width: "60px",}}/>
                    
                  </BottomNavigation>
                </Box>
                <MainPage privateMode={privateMode} setPrivateMode={setPrivateMode} userData={userData} setUserInfo={setUserInfo} setUserBox={setUserBox}/>
              </CardContent>
              {/* <Filter filterOpen={filterOpen} setFilterOpen={setFilterOpen} userData={userData} setUserData={setUserData}/> */}
              <UserDetails userBox={userBox} setUserBox={setUserBox} userInfo={userInfo}/>
            </Card>
          </Container>
      </Box>
    </Box>
  </Box>

  );
};

export default Demo;